import "./breadcrumbs.scss";

import {
    getKnownLocalePrefixes,
    getKnownLocales,
    normalizeLocale,
} from "@frontend/js/utils/locale";
import ArrowRightChevronIcon from "@frontend/images/icons/ArrowRightChevronIcon";
import { Link, usePage } from "@inertiajs/react";
import useT from "@frontend/js/hooks/useT";
import useRoute from "@frontend/js/hooks/useRoute";

export default function Breadcrumbs({
    currentTitle = "",
    currentTitleKey = null,
    parentTitle = "",
    parentTitleKey = null,
    parentHref = null,
    grandparentTitle = "",
    grandparentHref = null,
}) {
    const { props, url } = usePage();
    const { t } = useT("site");
    const route = useRoute();

    const knownLocales = getKnownLocales(props?.siteLanguages || []);
    const knownLocalePrefixes = getKnownLocalePrefixes(
        props?.siteLanguages || [],
    );
    const firstPathSegment = normalizeLocale(
        (url || "").split("/").filter(Boolean)[0],
    );
    const pathWithoutLocale =
        knownLocales.includes(firstPathSegment) ||
        knownLocalePrefixes.includes(firstPathSegment)
            ? (url || "").split("/").filter(Boolean).slice(1)
            : (url || "").split("/").filter(Boolean);
    const isHomePage = pathWithoutLocale.length === 0;

    const displayTitle = currentTitleKey
        ? t(currentTitleKey, currentTitle)
        : currentTitle;
    const displayParentTitle = parentTitleKey
        ? t(parentTitleKey, parentTitle)
        : parentTitle;

    if (isHomePage) {
        return null;
    }

    return (
        <nav className="breadcrumbs" aria-label="Breadcrumb">
            <Link className="breadcrumbs__home" href={route("frontend.home")}>
                {t("home-page")}
            </Link>
            {grandparentHref && grandparentTitle ? (
                <>
                    <ArrowRightChevronIcon />
                    <Link className="breadcrumbs__home" href={grandparentHref}>
                        {grandparentTitle}
                    </Link>
                </>
            ) : null}
            {parentHref && displayParentTitle ? (
                <>
                    <ArrowRightChevronIcon />
                    <Link className="breadcrumbs__home" href={parentHref}>
                        {displayParentTitle}
                    </Link>
                </>
            ) : null}
            <ArrowRightChevronIcon />
            <span className="breadcrumbs__current">{displayTitle}</span>
        </nav>
    );
}
